import { router } from "../data/Services/ordersRouter.jsx";
import { convertOrderObjectToRouterOrder } from "./orderConversions.js";
import { useOrderStore } from "../store/orderStore.jsx";

/**
 * Shared utility function for submitting orders to the router
 * Handles router connection check and opens login modal if needed
 *
 * @param {Object} order - Order object with { symbol, side, quantity, price, orderType }
 * @param {Function} onLoginRequired - Callback to open login modal
 * @param {Function} onSuccess - Callback for successful submission
 * @param {Function} onError - Callback for error handling
 * @returns {Promise<boolean>} - Returns true if submitted, false if login required
 */
export const submitOrderToRouter = async (
  order,
  onLoginRequired,
  onSuccess,
  onError,
) => {
  try {
    // Check if router is connected
    console.log("🔍 Router state check:", {
      state: router.state,
      isOnline: router.state === "online",
    });
    if (router.state !== "online") {
      console.log("📡 Router not online, opening login modal");
      console.log("🔍 onLoginRequired callback:", {
        exists: !!onLoginRequired,
        type: typeof onLoginRequired,
        value: onLoginRequired,
      });
      if (onLoginRequired) {
        console.log("✅ Calling onLoginRequired callback");
        onLoginRequired();
      } else {
        console.log("❌ No onLoginRequired callback provided");
      }
      return false;
    }

    // Validate required fields
    if (!order.symbol || !order.side || !order.quantity) {
      throw new Error("Dados da ordem incompletos");
    }

    // Convert order object to router format using shared utility
    const routerOrder = convertOrderObjectToRouterOrder(order);

    // Persist OTO legs (overlay-shaped) so the report-driven order can re-attach
    // them in the live session. Without this, direct-submit paths (shift+click on
    // chart/book) render the order with no Gain/Loss legs until a full reload pulls
    // the nested OTO from accountData.
    // #355: keia por order-id (+ símbolo p/ o fallback FIFO), não só por símbolo —
    // dois brackets rápidos no mesmo símbolo não se sobrescrevem mais.
    if (Array.isArray(order.oto) && order.oto.length > 0) {
      useOrderStore
        .getState()
        .storePendingOTO(routerOrder.id, routerOrder.symbol, order.oto);
    }

    // Submit to router
    await router.placeOrder(routerOrder);

    if (onSuccess) onSuccess(routerOrder.id, routerOrder);

    return true;
  } catch (error) {
    console.error("❌ Error submitting order:", error);
    if (onError) onError(error);
    return false;
  }
};
